import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Avvia un job AI asincrono e attende il completamento tramite polling.
// `startPromise` è la Promise della POST che ritorna { job_id }.
export async function runAiJob(startPromise, { interval = 2500, timeout = 240000 } = {}) {
  const { data } = await startPromise;
  const jobId = data.job_id;
  if (!jobId) return data; // retrocompatibilità: risposta sincrona
  const start = Date.now();
  // eslint-disable-next-line no-constant-condition
  while (true) {
    await new Promise((r) => setTimeout(r, interval));
    const { data: job } = await api.get(`/ai-jobs/${jobId}`);
    if (job.status === "done") return job.result;
    if (job.status === "error") throw new Error(job.error || "Generazione AI non riuscita");
    if (Date.now() - start > timeout) throw new Error("Timeout: la generazione AI sta impiegando troppo tempo. Riprova.");
  }
}

export default api;
